import React from 'react'
import axios from 'axios'

import './LoginEtica.css'
import brasao from '../../assets/brasil.jpeg'
import mbtech from '../../assets/mbtech.svg'

const initialState = {
    user: {
        matricula: '',
        password: ''
    }
}

export default class LoginEtica extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState }
    }

    updateField(event) {
        const user = { ...this.state.user }
        user[event.target.name] = event.target.value
        this.setState({ user })
    }

    login() { 
        const url = '/api/authEtica'
        const user = { ...this.state.user }
        axios.post(url, user)
            .then(res => {
                const { token, payload } = res.data
                localStorage.setItem('tokenY', token)
                localStorage.setItem('idE', payload.user.id)
                localStorage.setItem('nomeE', payload.user.nome)
                localStorage.setItem('matriculaE', payload.user.matricula)
                localStorage.setItem('tipoE', payload.user.tipo)
                localStorage.setItem('profissaoE', payload.user.profissao)
                localStorage.setItem('pronomeE', payload.user.pronome)
                localStorage.setItem('crefitoE', payload.user.crefito)
                
                return window.location = "/etica"
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            });
    }

    render() {
        return (
            <React.Fragment>
                <div className="mx-auto quadrado">
                    <div className="form">
                        <img src={brasao} alt="Brasil" className='brasao' />

                        <label className='label label1'>Usuário</label>
                        <input type="text" className='inputField'
                            name="matricula"
                            value={this.state.matricula}
                            onChange={e => this.updateField(e)} />

                        <label className='label label2'>Senha</label>
                        <input type="password" className='inputField'
                            name="password"
                            value={this.state.password}
                            onChange={e => this.updateField(e)} />

                        <button className='botaoEntrar' onClick={e => this.login()}>Entrar</button>
                    </div>
                    <img src={mbtech} alt="mbtech" className='mbtech' />
                </div>
            </React.Fragment>
        )
    }
}